module.exports = __webpack_public_path__ + "files/aede68e17e2fc82c67d5ec64d747e362.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/windows_dark.png
// module id = 836
// module chunks = 60